/**************************************************
 * Nombre:       Detalle_Detalle_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Divider, Grid, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import {Check, ShoppingCart} from '@mui/icons-material'
import {useTabsEspecificaciones} from "../../Componentes/Hooks/useTabsEspecificaciones";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";


const Detalle_Detalle_Producto = () => {
    const {sCell} = useResponsive()
    const {TabsEspecificaciones} = useTabsEspecificaciones({items: []});

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 24, fontWeight: 600, lineHeight: 1.2}}>Gafas optamilcas hombre Totoo</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 16, fontWeight: 600}}>
                    Marca:
                    <span style={{fontWeight: 400, paddingLeft: 6}}>
                    Kenarban
                    </span>
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Typography sx={{fontSize: 14, fontWeight: 400, color: '#00000090'}}>
                    Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha
                    sido el texto de relleno estándar de las industrias desde el año 1500
                </Typography>
            </Grid>


            <Grid
                container
                justifyContent={'space-between'}
                alignItems={'flex-end'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 4}}>


                <Typography sx={{fontSize: 24, fontWeight: 600, color: '#00000090'}}>
                    $ 150.000
                </Typography>

                <Typography sx={{fontSize: 16, fontWeight: 600, color: theme.palette.primary.main}}>
                    En Stock
                </Typography>

            </Grid>

            <Divider sx={{width: '100%', mt: 1}}/>

            <Grid
                container
                justifyContent={'space-between'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 2}}
                spacing={ sCell ? 2 :4.5}
            >
                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Button
                        startIcon={<ShoppingCart/>}
                        fullWidth variant={'outlined'}
                        sx={{pt: 1, pb: 1}}
                        color={'info'}
                    >
                        Agregar al Carrito
                    </Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Button
                        startIcon={<Check/>}
                        fullWidth
                        sx={{pt: 1, pb: 1}}
                        color={'info'}
                    >
                        Comprar Ahora
                    </Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 5}}>
                    <TabsEspecificaciones/>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Detalle_Detalle_Producto    